import { CmdTooltip } from '@commander-services/gui-components';
import { useIntl } from 'react-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import dayjs from 'dayjs';
import React from 'react';
import * as ExportState from '../Export/ExportState';
import { IDownload } from '../Export/ExportState';
import LoaderService from '../../Services/LoaderService';
import { ICmdTableFilter } from '../CmdTable/types';
import { TABLE_REFUELING_KEY } from './constants';
import { filterForRequestAtomFamily, sortFilterAtomFamily } from '../CmdTable/CmdTableState';
import useAnalytics from '../../hooks/useAnalytics';
import { getExport, getTableName } from '../CmdTable/CmdTableService';
import { selectedVehiclesAtom } from '../../store/recoil/vehicles';

const EXPORT_URL = '/v2/report/103/export';

export default function Export(): React.JSX.Element {
  const { formatMessage: f } = useIntl();
  const filterForRequest = useRecoilValue<ICmdTableFilter>(
    filterForRequestAtomFamily(TABLE_REFUELING_KEY)
  );
  const setIsActiveExport = useSetRecoilState<false | string>(ExportState.isActive);
  const sortFilter = useRecoilValue<{ [key: string]: string }>(
    sortFilterAtomFamily(TABLE_REFUELING_KEY)
  );
  const setDownloads = useSetRecoilState<IDownload[]>(ExportState.downloads);
  const selectedVehicles: number[] = useRecoilValue<number[]>(selectedVehiclesAtom);
  const { trackEvent } = useAnalytics();

  const handleExport = async () => {
    trackEvent([`table ${getTableName(TABLE_REFUELING_KEY)}`, 'click', 'Download refuelings']);
    LoaderService.showLoader(true);
    let newFilterRequest: ICmdTableFilter = { ...filterForRequest };
    if (filterForRequest.name && typeof filterForRequest.name === 'object') {
      newFilterRequest = {
        ...filterForRequest,
        name: Object.values(filterForRequest.name),
      };
    }
    const data = {
      filter: {
        ...newFilterRequest,
        vehicleId: selectedVehicles,
      },
      sort: {
        ...sortFilter,
      },
    };
    const response = await getExport(EXPORT_URL, data);
    if (response) {
      setIsActiveExport(response.jobId);
      setDownloads((oldState: IDownload[]) => {
        const job = oldState.find((item: IDownload) => item.jobId === response.jobId);
        if (job) {
          const updatedJob: IDownload = {
            ...job,
            isDownloaded: false,
            code: 'Refuelings',
            percentage: 0,
            generating_end: dayjs().toISOString(),
          };
          return [
            ...oldState.filter((item: IDownload) => item.jobId !== response.jobId),
            updatedJob,
          ];
        }
        const newJob: IDownload = {
          jobId: response.jobId,
          isDownloaded: false,
          code: 'Refuelings',
          percentage: 0,
          generating_start: dayjs().toISOString(),
          generating_end: null,
          filename: 'Refuelings',
        };
        return [...oldState, newJob];
      });
    }
    LoaderService.showLoader(false);
  };

  return (
    <div className="col-12 col-md-auto">
      <CmdTooltip
        content={f({ id: 'refuelings.export.download.tooltip' })}
        customCss={{ whiteSpace: 'pre-wrap', top: '38px' }}
        width={150}
      >
        <button
          onClick={handleExport}
          className="e-button e-button--square px-2"
          data-cy="cmd-table-export"
          type="button"
        >
          <i className="cmd-icons cmd-icon-download mr-2" />
          {f({ id: 'refuelings.export.download' })}
        </button>
      </CmdTooltip>
    </div>
  );
}
